import {
  BrainIcon,
  EyeIcon,
  ZapIcon,
  ActivityIcon,
  ShieldCheckIcon,
  ScaleIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface FeaturedProduct {
  title: string
  description: string
  icon: LucideIcon
  iconClass: string
  image: string
}

export const featuredProducts: FeaturedProduct[] = [
  {
    title: 'OmniMem',
    description: 'Digitálna pamäť firmy. E-maily, meetingy a dokumenty v jednom celku — nájdete čokoľvek za sekundu.',
    icon: BrainIcon,
    iconClass: 'text-apple-blue',
    image: 'https://images.unsplash.com/photo-1532619675605-1ede6c2ed2b0?w=480&h=240&fit=crop&crop=center',
  },
  {
    title: 'VibeStyle AI',
    description: 'Vizuály, ktoré sedia vašej značke. AI pozná váš štýl a prispôsobí mu každý výstup.',
    icon: EyeIcon,
    iconClass: 'text-purple-600',
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?w=480&h=240&fit=crop&crop=center',
  },
  {
    title: 'EchoVision Pro',
    description: 'Priestorový zvuk z obrazu scény. Nevidiaci „počujú" prekážky, ľudí aj objekty okolo seba.',
    icon: ZapIcon,
    iconClass: 'text-amber-600',
    image: 'https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=480&h=240&fit=crop&crop=center',
  },
  {
    title: 'SkillStream',
    description: 'Učenie remesiel cez kameru a hlas. AI sleduje vaše ruky a vedie vás krok za krokom.',
    icon: ActivityIcon,
    iconClass: 'text-emerald-600',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=480&h=240&fit=crop&crop=center',
  },
  {
    title: 'MediMatch',
    description: 'Prvotné vyhodnotenie z fotky a zvuku. AI pomáha lekárovi s diagnostikou na diaľku.',
    icon: ShieldCheckIcon,
    iconClass: 'text-rose-600',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=480&h=240&fit=crop&crop=center',
  },
  {
    title: 'LawLens',
    description: 'Odfotíte zmluvu a spýtate sa. AI ju vysvetlí bez právnického žargónu.',
    icon: ScaleIcon,
    iconClass: 'text-indigo-600',
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=480&h=240&fit=crop&crop=center',
  },
]

export const moreProducts = [
  '07. Diagnostika áut podľa zvuku motora',
  '08. Recepty z pohľadu do chladničky',
  '09. Sledovanie nálady podľa hlasu',
  '10. Preklad s porozumením gest a emócií',
  '11. Filmová hudba z hmkania melódie',
  '12. Domáca bezpečnosť, ktorá chápe situácie',
  '13. Hľadanie autentických miest podľa zvukov',
  '14. Analýza mimiky pri online predaji',
  '15. Nakresli appku na papier — AI ju vytvorí',
  '16. Automatické triedenie fotiek z eventov',
  '17. Vizuálna kontrola dodávateľského reťazca',
  '18. Diskusia s videoprednáškou v reálnom čase',
  '19. Skladový manažment cez fotoaparát',
  '20. Analýza pohybu pre športovcov',
]

export const deliveryPrinciples = [
  {
    title: 'Kvalita',
    desc: 'Dostupnosť 99,99 %. Riešenie beží spoľahlivo, aj keď ho používajú tisíce ľudí naraz.',
    icon: ShieldCheckIcon,
  },
  {
    title: 'Rýchlosť',
    desc: 'Odozva pod 50 ms. Všetko reaguje okamžite — bez čakania a zasekávania.',
    icon: ZapIcon,
  },
]
